<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed z-30 inset-0 overflow-y-auto" @close="closeModal">
      <div
        class="flex items-end justify-center h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="
              relative
              inline-block
              align-bottom
              rounded-lg
              text-left
              shadow-xl
              transform
              transition-all
              sm:align-middle
              p-5
              w-full
              h-screen
              bg-white
            "
            @wheel="preventZoom($event)"
          >
            <h1 class="text-gray-700 font-semibold leading-6 pt-2 pb-4">
              Define the area of the content you want to share with the attendees.
            </h1>
            <div class="bg-vice-dark-grey px-60 py-5 cropper">
              <Cropper
                :src="screenShareImage"
                @change="change"
                v-if="enableCropping && isCropScreenSupported"
              />
              <img :src="screenShareImage" alt="ScreenPreview" v-else />
            </div>
            <div class="flex justify-between mt-8">
              <button
                class="
                  bg-white
                  rounded-md
                  border
                  py-2
                  px-6
                  shadow-sm
                  font-medium
                  text-gray-700 text-base
                "
                @click="stopScreenshareStream"
              >
                Cancel
              </button>

              <!-- <button
                class="
                  bg-white
                  rounded-md
                  border
                  py-2
                  px-6
                  shadow-sm
                  font-medium
                  text-gray-700 text-base
                  flex
                "
                v-if="isCropScreenSupported"
                @click="enableCropping = !enableCropping"
              >
                <CropContentIcon class="mr-2" />
                Toggle Crop content
              </button> -->

              <button
                class="
                  bg-vice-teal-500
                  rounded-md
                  border
                  py-2
                  px-6
                  shadow-sm
                  font-medium
                  text-white text-base
                "
                @click="postProcessScreenshare"
              >
                Share content
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { ref, toRaw } from 'vue';
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { Cropper } from 'vue-advanced-cropper';
import ScreensharePreprocessor from '@/Services/ScreensharePreprocessor';
// import CropContentIcon from '@/Components/Icons/CropContentIcon';
import 'vue-advanced-cropper/dist/style.css';

export default {
  name: 'VideoCroppingModal',
  components: {
    Dialog,
    Cropper,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
    // CropContentIcon,
  },
  emits: ['closeVideoCroppingModal', 'share-screen-to-participants'],
  props: {
    open: {
      type: Boolean,
    },
    screenShareImage: {
      type: String,
    },
    stopScreenshareStream: {
      type: Function,
    },
  },
  setup(props, { emit }) {
    const coordinates = ref({
      x: 0,
      y: 0,
      width: 0,
      height: 0,
    });
    const enableCropping = ref(true);
    const isCropScreenSupported = new ScreensharePreprocessor().isMediaProcessingSupported();
    const closeModal = () => {
      emit('close');
    };

    const change = (data) => {
      coordinates.value = data.coordinates;
    };

    const postProcessScreenshare = () => {
      emit('share-screen-to-participants', toRaw(coordinates.value));
    };

    const preventZoom = (event) => {
      event.preventDefault();
    };

    return {
      change,
      closeModal,
      postProcessScreenshare,
      preventZoom,
      enableCropping,
      isCropScreenSupported,
    };
  },
};
</script>

<style scoped>
.cropper {
  max-height: calc(100vh - 12.5rem);
  height: 100%;
  width: 100%;
  background: #ddd;
}
</style>
